//=================================================
//    summary: DCP Learning Unit Tool Tip -- Hook
//
//    remarks: 000 Tim 2022/01/12 Create
//================================================
import React, { useEffect } from 'react'
import cssLearningUnitToolTip from './LearningUnitToolTip.module.scss'
import {GlobalLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mintAccountRole = 0
// #endregion Member Variables


const COMP_NAME = "LearningUnitToolTip"

function LearningUnitToolTip(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            mintAccountRole = 0
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowLearningUnitToolTip"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler
    // #endregion OnTapHandler

    // #region Get ClassName
    /*===========================================
    summary: 取得 ToolTipMain Cls
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function GetToolTipMainCls(AccountRole) 
    {
        let objCls = cssLearningUnitToolTip.divToolTipMain4Teacher

        if (AccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            objCls = cssLearningUnitToolTip.divToolTipMain4Student
        }

        return objCls
    } // end of GetToolTipMainCls

    /*===========================================
    summary: 取得 ToolContentArea Cls
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function GetToolContentAreaCls(AccountRole) 
    {
        let objCls = cssLearningUnitToolTip.divToolContentArea4Teacher

        if (AccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            objCls = cssLearningUnitToolTip.divToolContentArea4Student
        }

        return objCls
    } // end of GetToolContentAreaCls
    // #endregion Get ClassName

    // #region Render
    /*===========================================
    summary: Render Tool Tip Content Area 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderGoogleClassroomTipContentAreaWrapper()
    {
        return (
            <div className={cssLearningUnitToolTip.divGoogleClassroomTipContentArea}>
                <div className={cssLearningUnitToolTip.divGoogleClassroomMemo}>
                    {window.gAppUI.LBL_GCTip}
                </div>
            </div>
        )
    } // end of RenderGoogleClassroomTipContentAreaWrapper

    /*===========================================
    summary: Render Tool Tip Main 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderGoogleClassroomTipMainWrapper()
    {
        // console.log(COMP_NAME + ".RenderGoogleClassroomTipMainWrapper: ")
        let objBlock = null

        if (!window.gConfig.ForChina)
        {
            let objBlockGoogleClassroomTip = (
                <div className={cssLearningUnitToolTip.divGoogleClassroomTipMain}>
                    <div className={cssLearningUnitToolTip.divGoogleClassroomTriangle}/>
                    {RenderGoogleClassroomTipContentAreaWrapper()}
                </div>
            )

            // 非China
            if (!window.gSession.App.InApp)
            {
                objBlock = objBlockGoogleClassroomTip
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlock = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlock = objBlockGoogleClassroomTip
                }
            }
        }
        return objBlock
    } // end of RenderGoogleClassroomTipMainWrapper

    /*===========================================
    summary: Render AssignContentArea 的顯示
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function RenderAssignContentAreaWrapper(AccountRole)
    {
        if (AccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            return (
                <div className={cssLearningUnitToolTip.divAssignContentArea}>
                    <div className={cssLearningUnitToolTip.divAssignButtonMain}>
                        <div className={cssLearningUnitToolTip.divAssignIcon}/>
                        
                        <div className={cssLearningUnitToolTip.divAssignButtonText}>
                            {window.gAppUI.LBL_Assign}
                        </div>
                    </div>

                    <div className={cssLearningUnitToolTip.divAssignDesc}>
                        {window.gAppUI.LBL_AssignTip}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAssignContentAreaWrapper

    /*===========================================
    summary: Render NoteContentArea 的顯示
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function RenderNoteContentAreaWrapper()
    {
        return (
            <div className={cssLearningUnitToolTip.divNoteContentArea}>
                <div className={cssLearningUnitToolTip.divNoteButtonMain}>
                    <div className={cssLearningUnitToolTip.divNoteIcon}/>
                    
                    <div className={cssLearningUnitToolTip.divNoteButtonText}>
                        {window.gAppUI.LBL_Note}
                    </div>
                </div>

                <div className={cssLearningUnitToolTip.divNoteDesc}>
                    {window.gAppUI.LBL_NoteTip}
                </div>
            </div>
        )
    } // end of RenderNoteContentAreaWrapper

    /*===========================================
    summary: Render Tool Content Area 的顯示
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function RenderToolContentAreaWrapper(AccountRole)
    {
        let strToolTip = window.gAppUI.LBL_ToolTipTeacher
        if (AccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            strToolTip = window.gAppUI.LBL_ToolTipStudent
        }

        return (
            <div className={GetToolContentAreaCls(AccountRole)}>
                <div className={cssLearningUnitToolTip.divToolIcon}/>
                
                <div className={cssLearningUnitToolTip.divToolDesc}>
                    {strToolTip}
                </div>
            </div>
        )
    } // end of RenderToolTipContentAreaWrapper

    /*===========================================
    summary: Render Tool Tip Content Area 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderToolTipContentAreaWrapper()
    {
        return (
            <div className={cssLearningUnitToolTip.divToolTipContentArea}>
                {RenderToolContentAreaWrapper(mintAccountRole)}

                <div className={cssLearningUnitToolTip.divLine}/>

                {RenderNoteContentAreaWrapper()}

                {RenderAssignContentAreaWrapper(mintAccountRole)}
            </div>
        )
    } // end of RenderToolTipContentAreaWrapper

    /*===========================================
    summary: Render Tool Tip Main 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderToolTipMainWrapper()
    {
        return (
            <div className={GetToolTipMainCls(mintAccountRole)}>
                {RenderToolTipContentAreaWrapper()}
                <div className={cssLearningUnitToolTip.divToolTriangle}/>
            </div>
        )
    } // end of RenderToolTipMainWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                {RenderToolTipMainWrapper()}
                {RenderGoogleClassroomTipMainWrapper()}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssLearningUnitToolTip.divMask} onClick={() => CloseOnTapHandler()}>
                {RenderContentWrapper()}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default LearningUnitToolTip